// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-1b1c2bcc]{backface-visibility:hidden;perspective:1000px;transform:translateZ(0);will-change:height}.expand-enter-active[data-v-1b1c2bcc],.expand-leave-active[data-v-1b1c2bcc]{overflow:hidden;transition-duration:.15s;transition-property:height;transition-timing-function:ease-in-out}.expand-enter[data-v-1b1c2bcc],.expand-leave-to[data-v-1b1c2bcc]{height:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
